// Author : Ayesha Shaikh
// created on 27-07-2024

import React, { useEffect, useState } from "react";
import MainCard from "../../../components/Maincard";
import {
 
  Button,
  Checkbox,
  Collapse,
  Drawer,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
 
  Typography,
} from "@mui/material";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function EmployeeLeaveFilter({
  onApplyFilter,
  onResetFilter,
  open,
  handleToggle,
}) {
  const userRole = localStorage.getItem("userRole");
  const userId = localStorage.getItem("userId");

  const [createdBylist, setCreatedBylist] = useState([]);
  const [createdby, setCreatedby] = useState([]);
  const [branchlist, setBranchlist] = useState([]);
  const [branch, setBranch] = useState([]);
  const [status, SetStaus] = useState([]);
  const [applicationType, setApplicationType] = useState([]);
  const [leaveTypeList, setLeaveTypeList] = useState([]);
  const [leaveType, setLeaveType] = useState([]);
  const [requestedFrom, setRequestedFrom] = useState("");
  const [requestedTo, setRequestedTo] = useState("");
  const [leaveFrom, setLeaveFrom] = useState("");
  const [leaveTo, setLeaveTo] = useState("");
  const [leaveStartfrom, setLeaveStartFrom] = useState("");
  const [leaveStartTo, setLeaveStartTo] = useState("");
  const [leaveEndfrom, setLeaveEndFrom] = useState("");
  const [leaveEndTo, setLeaveEndTo] = useState("");
  const [showRequestedDateField, setShowRequestedDateField] = useState(false);
  const [showLeaveFromDate, setShowLeaveFromDate] = useState(false);
  const [showLeaveEndDate, setShoweLeaveEnddate] = useState(false);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}route/getalluser`)
      .then((response) => response.json())
      .then((data) => {
        const sortedData = data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        const filterData = sortedData.filter((i) => i.id === parseInt(userId));

        if (userRole === "admin") {
          setCreatedBylist(sortedData);
        } else {
          setCreatedBylist(filterData);
        }
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  }, []);

  const [statusList, setStatusList] = useState([
    { id: 1, name: "Pending", value: "pending" },
    { id: 2, name: "Accepted", value: "accepted" },
    { id: 3, name: "Denied", value: "denied" },
    { id: 4, name: "Cancelled", value: "cancelled" },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch`);
        if (response.ok) {
          const data = await response.json();

          setBranchlist(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const [applicationTypeList, setApplicationTypeList] = useState([
    { id: 1, name: "First Half Day", value: "first_half" },
    { id: 1, name: "Full Day", value: "full" },
    { id: 1, name: "Second Half Day", value: "second_half" },
    { id: 1, name: "Short Leave - Morning", value: "short_morning" },
    { id: 1, name: "Short Leave - Evening", value: "short_evening" },
  ]);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}empleavetype`)
      .then((response) => response.json())
      .then((data) => {
        const sortedData = data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        setLeaveTypeList(sortedData);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  }, []);

  const allCreatedByList = [{ first_name: "Select All" }, ...createdBylist];
  const handelcretedby = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setCreatedby(createdBylist);
    } else {
      setCreatedby(value);
    }
  };

  const allStatusList = [{ name: "Select All" }, ...statusList];
  const handleStatusChange = (event, value) => {
    if (value.some((option) => option.name === "Select All")) {
      SetStaus(statusList);
    } else {
      SetStaus(value);
    }
  };

  const allbranchList = [{ branch_name: "Select All" }, ...branchlist];
  const handelbranchchange = (event, value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      setBranch(branchlist);
    } else {
      setBranch(value);
    }
  };

  const allApplicationhList = [{ name: "Select All" }, ...applicationTypeList];
  const handelApplicationchange = (event, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setApplicationType(applicationTypeList);
    } else {
      setApplicationType(value);
    }
  };

  const allLeavetype = [{ leave_type: "Select All" }, ...leaveTypeList];
  console.log(allLeavetype);
  const handleLeavetypeChange = (event, value) => {
    if (value.some((option) => option.leave_type === "Select All")) {
      setLeaveType(leaveTypeList);
    } else {
      setLeaveType(value);
    }
  };

  const handleRequestedFrom = (e) => {
    setRequestedFrom(e.target.value);
  };

  const handleRequestedTo = (e) => {
    setRequestedTo(e.target.value);
  };

  const handleLeaveFrom = (e) => {
    setLeaveFrom(e.target.value);
  };

  const handleLeaveTo = (e) => {
    setLeaveTo(e.target.value);
  };
  const newCreatedby = createdby.map((i) => i.id);
  const newStatus = status.map((i) => i.value);
  const newBranch = branch.map((i) => i.branch_name);
  const newApplicationType = applicationType.map((i) => i.value);
  const newLeaveType = leaveType.map((i) => i.id);

  const handleApplyFilter = () => {
    onApplyFilter({
      newCreatedby,
      newStatus,
      newBranch,
      newApplicationType,
      newLeaveType,
      requestedFrom,
      requestedTo,
      leaveFrom,
      leaveTo,
      leaveStartfrom,
      leaveStartTo,
      leaveEndfrom,
      leaveEndTo,
    });

    handleToggle();
  };

  const handleResetFilter = () => {
    onResetFilter();
    setCreatedby([]);
    SetStaus([]);
    setBranch([]);
    setApplicationType([]);
    setLeaveType([]);
    setRequestedFrom("");
    setRequestedTo("");
    setLeaveFrom("");
    setLeaveTo("");
  };

  const handleCheckboxChange = (event) => {
    setShowRequestedDateField(event.target.checked);
  };

  const handleLeaveFromDate = (e) => {
    setShowLeaveFromDate(e.target.checked);
  };

  const handleLeaveToDate = (e) => {
    setShoweLeaveEnddate(e.target.checked);
  };

  const handleleaveStartfrom = (e) => {
    setLeaveStartFrom(e.target.value);
  };

  const handleleaveStartTo = (e) => {
    setLeaveStartTo(e.target.value);
  };

  const handleLeaveEndFrom = (e) => {
    setLeaveEndFrom(e.target.value);
  };

  const handleLeaveEndTo = (e) => {
    setLeaveEndTo(e.target.value);
  };

  return (
    <>
      <Drawer anchor="right" open={open} onClose={handleToggle}  sx={{
          "& .MuiDrawer-paper": {
            width: {
              xs: "auto", // No specific width for the drawer on xs screens
              sm: "400px",
            },
          },
        }}>
        <Grid container spacing={2} sx={{
            px: "16px",
            mt: 1,
            overflow: "auto",
            height: { md: "115vh", lg: "93vh" },
          }}>
          <Grid item xs={12}>
            <Typography variant="h3" textAlign="center">
              Filter Options
            </Typography>
          </Grid>

          <Grid item xs={12} lg={12} sm={12} md={12}>
            <Typography variant="h6">Employee Name </Typography>

            <CustomAutocompleteComp
              fullWidth
        
              value={createdby}
              multiple
              onChange={handelcretedby}
              options={allCreatedByList}
              getOptionLabel={(option) =>
                `${option.first_name ? option.first_name : ""} ${
                  option.last_name ? option.last_name : ""
                }`
              }
              tooltipContent={(option) =>
                `${option.first_name ? option.first_name : ""} ${
                  option.last_name ? option.last_name : ""
                }`
              }
             
            />
          </Grid>

          <Grid item xs={12} lg={12} sm={12} md={12}>
            <Typography variant="h6">Select Status </Typography>

            <CustomAutocompleteComp
              fullWidth
              
              value={status}
              multiple
              onChange={handleStatusChange}
              options={allStatusList}
              getOptionLabel={(option) => option.name}
              tooltipContent={(option) => option.name}
             
            />
          </Grid>
          <Grid item xs={12} lg={12} sm={12} md={12}>
            <Typography variant="h6"> Select Branch </Typography>
            <CustomAutocompleteComp
              
              value={branch}
              multiple
              onChange={handelbranchchange}
              options={allbranchList}
              getOptionLabel={(option) => option.branch_name}
              tooltipContent={(option) => option.branch_name}
            
            />
          </Grid>

          <Grid item xs={12} lg={12} sm={12} md={12}>
            <Typography variant="h6"> Select Application Type </Typography>

            <CustomAutocompleteComp
             
              value={applicationType}
              multiple
              onChange={handelApplicationchange}
              options={allApplicationhList}
              getOptionLabel={(option) => option.name}
              tooltipContent={(option) => option.name}
           
            />
          </Grid>

          <Grid item xs={12} lg={12} sm={12} md={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={6} sm={6} md={6}>
                <Typography variant="h6"> Select Leave Date from </Typography>
                <CustomTextFieldComp
                  value={leaveFrom}
                  onChange={handleLeaveFrom}
                  type="date"
                  size="normal"
                  fullWidth
                  InputProps={{
                    style: { borderRadius: "10px" },
                  }}
                />
              </Grid>

              <Grid item xs={12} lg={6} sm={6} md={6}>
                <Typography variant="h6"> Select Leave Date To </Typography>
                <CustomTextFieldComp
                  value={leaveTo}
                  onChange={handleLeaveTo}
                  type="date"
                  size="normal"
                  fullWidth
                  InputProps={{
                    style: { borderRadius: "10px" },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={12} sm={12} md={12}>
            <Typography variant="h6"> Select Leave Type </Typography>

            <CustomAutocompleteComp
              
              value={leaveType}
              multiple
              onChange={handleLeavetypeChange}
              options={allLeavetype}
              getOptionLabel={(option) => option.leave_type}
              tooltipContent={(option) => option.leave_type}
              
            />
          </Grid>

          <Grid item xs={12} lg={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showRequestedDateField}
                    onChange={handleCheckboxChange}
                  />
                }
                label={
                  <Typography variant="h6">
                    Filter With Requested Date Only
                  </Typography>
                }
              />
            </FormGroup>
          </Grid>

          {showRequestedDateField && (
            <Grid item xs={12} lg={12} sm={12} md={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={12} sm={12} md={12}>
                  <Typography
                    textAlign="center"
                    sx={{ fontWeight: 600, fontSize: "16px" }}
                  >
                    Requested Date
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={6} sm={6} md={6}>
                  <Typography variant="h6"> Date Start From </Typography>
                  <CustomTextFieldComp
                    value={requestedFrom}
                    onChange={handleRequestedFrom}
                    type="date"
                    size="normal"
                    fullWidth
                    InputProps={{
                      style: { borderRadius: "10px" },
                    }}
                  />
                </Grid>

                <Grid item xs={12} lg={6} sm={6} md={6}>
                  <Typography variant="h6"> Date Start To </Typography>
                  <CustomTextFieldComp
                    value={requestedTo}
                    onChange={handleRequestedTo}
                    type="date"
                    size="normal"
                    fullWidth
                    InputProps={{
                      style: { borderRadius: "10px" },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}

          <Grid item xs={12} lg={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showLeaveFromDate}
                    onChange={handleLeaveFromDate}
                  />
                }
                label={
                  <Typography variant="h6">
                    Filter With Leave from Date Only
                  </Typography>
                }
              />
            </FormGroup>
          </Grid>

          {showLeaveFromDate && (
            <Grid item xs={12} lg={12} sm={12} md={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={12} sm={12} md={12}>
                  <Typography
                    textAlign="center"
                    sx={{ fontWeight: 600, fontSize: "16px" }}
                  >
                    Leave From Date
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={6} sm={6} md={6}>
                  <Typography variant="h6"> Date Start From </Typography>
                  <CustomTextFieldComp
                    value={leaveStartfrom}
                    onChange={handleleaveStartfrom}
                    type="date"
                    size="normal"
                    fullWidth
                    InputProps={{
                      style: { borderRadius: "10px" },
                    }}
                  />
                </Grid>

                <Grid item xs={12} lg={6} sm={6} md={6}>
                  <Typography variant="h6"> Date Start To </Typography>
                  <CustomTextFieldComp
                    value={leaveStartTo}
                    onChange={handleleaveStartTo}
                    type="date"
                    size="normal"
                    fullWidth
                    InputProps={{
                      style: { borderRadius: "10px" },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}

          <Grid item xs={12} lg={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showLeaveEndDate}
                    onChange={handleLeaveToDate}
                  />
                }
                label={
                  <Typography variant="h6">
                    Filter With Leave To Date Only
                  </Typography>
                }
              />
            </FormGroup>
          </Grid>

          {showLeaveEndDate && (
            <Grid item xs={12} lg={12} sm={12} md={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={12} sm={12} md={12}>
                  <Typography
                    textAlign="center"
                    sx={{ fontWeight: 600, fontSize: "16px" }}
                  >
                    Leave To Date
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={6} sm={6} md={6}>
                  <Typography variant="h6"> Date Start From </Typography>
                  <CustomTextFieldComp
                    value={leaveEndfrom}
                    onChange={handleLeaveEndFrom}
                    type="date"
                    size="normal"
                    fullWidth
                    InputProps={{
                      style: { borderRadius: "10px" },
                    }}
                  />
                </Grid>

                <Grid item xs={12} lg={6} sm={6} md={6}>
                  <Typography variant="h6"> Date Start To </Typography>
                  <CustomTextFieldComp
                    value={leaveEndTo}
                    onChange={handleLeaveEndTo}
                    type="date"
                    size="normal"
                    fullWidth
                    InputProps={{
                      style: { borderRadius: "10px" },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}

        
        </Grid>
        <Grid  
        container
          flexDirection="row"
         
        
          position="absolute"
          bottom={5}  justifyContent='end' gap={2} textAlign="end">
            <Button
              variant="contained"
          
            color="primary"
              onClick={handleApplyFilter}
            >
              {" "}
              Apply Filter
            </Button>
            <Button
              color="error"
              variant="contained"
            style={{marginRight:' 10px'}}
           
              onClick={handleResetFilter}
            >
              {" "}
            Reset Filter
            </Button>
          </Grid>
      </Drawer>
    </>
  );
}
